import { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
import DataTable from 'react-data-table-component';
import { GET_MY_LEDGER_REPORTS, GET_RESERVE_TRANSACTION_LIST_API, POST_RESERVE_TRANSACTION_API } from './../../../Utils/appConstants';
import { useHistory } from "react-router-dom";
import PropagateLoader from "react-spinners/PropagateLoader";
import { getRequest, postRequest } from './../../../Utils/AppApi';

import { Tooltip, Modal, Divider, Button } from 'antd';
import { getUTCToLocalDateTimeFormat } from './../../../Utils/function';
import { INRFormat, isNumber, reserveStatus } from '../../../Utils/Common';
import { toast } from 'react-toastify';

const ReserveBalance = () => {
    const history = useHistory();
    const [isLoading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState(null);
    const [serviceCode, setServiceCode] = useState(null);
    const [serviceName, setServiceName] = useState(null);
    const [isUserId, setUserId] = useState(null);
    const [isData, setData] = useState([]);
    const [isModel, setModel] = useState(false);
    const [isModelData, setModelData] = useState(null);
    const [getDataField, setDataField] = useState({});
    const [getDataError, setDataError] = useState({});

    const [isListView, setIsListView] = useState(true);

    const amountInput = useRef(null);
    const transactionIdInput = useRef(null);

    const clearFormField = () => {
        transactionIdInput.current.valueOf = null;
        amountInput.current.valueOf = null;
        setModelData(null);
        // bankSelect.current.value = { value: "", label: "" };
        setDataError({});
        setDataField([])
    }

    const FormValidate = () => {
        let formValid = true;
        let formObject = {};
        setDataError({})
        if (getDataField && getDataField.length === 0) {
            formValid = false;
        }
        let array = ["amount"];
        array.forEach(element => {
            if (getDataField[element] === "" || typeof getDataField[element] === "undefined") {
                formObject[element] = true;
                formValid = false;
            }
        });

        setDataError(formObject);
        return formValid;
    }

    const handleSearch = (e) => {
        // console.log("searchText----",e.target.value)
        setSearchText(e.target.value);
    }

    const objectToQueryString = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    const getLogHistory = async (data) => {
        setLoading(true);
        setIsListView(false);
        let params = {}
        if (data) {
            params.limit = data;
        }

        // if(props.userId) {
        //     params.userId = userId ? userId : props.userId;
        // }

        if (searchText) {
            params.searchTransId = searchText;
        }

        const queryString = objectToQueryString(params);
        getRequest(`${GET_MY_LEDGER_REPORTS}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
                // setTotalRecord(response.data.totalDocs);
                // setPage(response.data.page);
            } else {
                setData([]);
                // setTotalRecord(0);
                // setPage(1);
            }
            setLoading(false);
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
        })
    }

    const getListView = async (data) => {
        setLoading(true);
        setIsListView(true);
        let params = {}
        if (data) {
            params.limit = data;
        }

        if (searchText) {
            params.searchTransId = searchText;
        }

        const queryString = objectToQueryString(params);
        getRequest(`${GET_RESERVE_TRANSACTION_LIST_API}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
                // setTotalRecord(response.data.totalDocs);
                // setPage(response.data.page);
            } else {
                setData([]);
                // setTotalRecord(0);
                // setPage(1);
            }
            setLoading(false);
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
        })
    }

    const columns = [{
        name: 'Date Time',
        cell: row => getUTCToLocalDateTimeFormat(row.createdAt),
        width: "200px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }, {
        name: 'Trans ID',
        selector: row => <Tooltip placement="bottom" title={row.transactionId}>{row.transactionId}</Tooltip>,
        width: "180px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }, {
        name: 'Status',
        selector: row => '-',
    }, {
        name: 'Ref ID',
        selector: row => row.toUserData && row.toUserData.username,
        width: "150px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }, {
        name: 'Service Name',
        selector: row => <Tooltip placement="bottom" title={row.serviceName}>{row.serviceName}</Tooltip>,
        width: "200px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }, {
        name: 'Product',
        selector: row => <Tooltip placement="bottom" title={row.product}>{row.product}</Tooltip>,
        width: "200px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
        // }, {
        //     name: 'Name',
        //     selector: row => <Tooltip placement="bottom" title={row.toUserData && row.toUserData.name}>{row.toUserData && row.toUserData.name}</Tooltip>,
        //     width: "200px",
        //     headerStyle: (selector, id) => {
        //       return { textAlign: "center" };
        //     },
    }, {
        name: 'Opening Balance',
        selector: row => row.openingBalance ? INRFormat(row.openingBalance) : "-",
        width: "150px",
    }, {
        name: 'Debit',
        selector: row => (!row.debit) ? "-" : INRFormat(row.debit),
        width: "130px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }, {
        name: 'Credit',
        selector: row => (!row.credit) ? "-" : INRFormat(row.credit),
        width: "130px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }, {
        name: 'Ser. Charge',
        selector: row => row.serviceCharge ? INRFormat(row.serviceCharge) : "-",
    }, {
        name: 'Commission',
        selector: row => row.commission ? INRFormat(row.commission) : "-",
    }, {
        name: 'TDS',
        selector: row => row.tds ? INRFormat(row.tds) : "-",
    }, {
        name: 'Closing Balance',
        selector: row => INRFormat(row.closingBalance),
        width: "150px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }, {
        name: 'Description',
        selector: row => row.description ? <Tooltip placement="bottom" title={row.description && row.description}>{row.description && row.description}</Tooltip> : "-",
        width: "250px",
    }]

    const columnsListView = [{
        name: 'Date Time',
        cell: row => getUTCToLocalDateTimeFormat(row.createdAt),
        width: "200px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }, {
        name: 'Trans ID',
        selector: row => <Tooltip placement="bottom" title={row.transactionId}>{row.transactionId}</Tooltip>,
        width: "180px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }, {
        name: 'User ID',
        selector: row => row.users && row.users.username +' / '+ row.users.name,
        width: "250px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }, {
        name: 'Service Name',
        selector: row => <Tooltip placement="bottom" title={row.serviceName}>{row.serviceName}</Tooltip>,
        width: "180px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }, {
        name: 'Amount',
        selector: row => row.amount ? INRFormat(row.amount) : "-",
        width: "100px",
    }, {
        name: 'Status',
        selector: row => row.status ? reserveStatus(row.status) : "-",
        width: "100px",
    }, {
        name: 'Action',
        selector: row => row.status === "0" ? 
          <><Button type="primary" danger onClick={() => handleUnBlock(row, "2")}>Block</Button>
          <Button type="primary" className="ml-1" primary onClick={() => handleUnBlock(row, "1")}>Release</Button></> : "-",
        width: "230px",
        headerStyle: (selector, id) => {
            return { textAlign: "center" };
        },
    }, {
        name: 'Remark',
        selector: row => row.remark ? <Tooltip placement="bottom" title={row.remark}>{row.remark}</Tooltip> : "-",
        width: "250px",
    }]

    const handleListView = () => {
        setIsListView(true);
        getListView();
    }

    const handleChangeStatus = () => {
        setModel(true);
        if (isData && isData?.docs?.length > 0) {
            setServiceCode(isData?.docs[0]?.serviceCode);
            setServiceName(isData?.docs[0]?.serviceName);
            setUserId(isData?.docs[0]?.toUserId);
            setModelData(isData?.docs[0]);
            let object = {}
            object.amount = isData?.docs[0]?.transactionAmt;
            object.transactionId = isData?.docs[0]?.transactionId;
            setDataField(object)
        } else {
            setModelData(null);
        }
        // console.log("data ---------------------------------", isData?.docs)
    }

    const handleUnBlock = async (data, status) => {
        setLoading(true);
        let payload = { mode: "DELETE", status: status, id: data._id }
        postRequest(`${POST_RESERVE_TRANSACTION_API}`, payload, history).then((response) => {
            if (response.success === true) {
                getListView()
            }
            setLoading(false);
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
        })
    }

    const handleSubmit = async () => {
        if(FormValidate()) {
            setLoading(true);
            let payload = {
                mode: "ADD",
                transactionId: getDataField && getDataField.transactionId,
                serviceCode: serviceCode,
                serviceName: serviceName,
                amount: getDataField && getDataField.amount,
                userId: isUserId,
                refId: isModelData && isModelData.refId,
                remark: getDataField && getDataField.remark,
            }
            postRequest(`${POST_RESERVE_TRANSACTION_API}`, payload, history).then((response) => {
                if (response.success === true) {
                    setModel(false);
                    setIsListView(true);
                    getListView();
                    toast.success(response.message);
                    clearFormField();
                } else {
                    toast.error(response.message);
                }
                setLoading(false);
            }).catch(function (error) {
                console.log(error)
                setLoading(false);
            })
        }
    }

    const onChangeValue = (event) => {
        const { name, value } = event.target;
        setDataField({ ...getDataField, [name]: value });
    }

    useEffect(() => {
        getListView()
        // console.log("useEffect page-----", page)
        // if(page > 1){
        //     getLogHistory();
        // }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    if (isLoading) {
        return <div className="content text-center" style={{ margin: "250px 0" }}>
            <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
        </div>
    }
    return (
        <div>
            <div className="">
                <div className="content">
                    <div className="container-fluid">
                        <div className='card'>
                            <div className='card-body vh-100'>
                                <div className='row mb-3'>
                                    <div className="input-group col-md-8">
                                        <input className="form-control py-2 border" type="search" value={searchText} placeholder='Transaction ID' onChange={(e) => handleSearch(e)} />
                                        <button onClick={() => getLogHistory()} className="btn btn-primary pointer ml-3">Search</button>

                                        <button onClick={() => handleChangeStatus()} className="btn btn-warning pointer ml-3">Reserve Amount</button>

                                        <button onClick={() => handleListView()} className="btn btn-success pointer ml-3">Reserve List View</button>
                                    </div>
                                </div>
                                <Divider />
                                <div className="container-fluid pt-2 pb-5">
                                    <DataTable
                                        title={""}
                                        columns={ isListView ? columnsListView : columns}
                                        data={isData.docs}
                                        progressPending={isLoading}
                                        highlightOnHover
                                        pagination
                                        paginationServer
                                        // paginationTotalRows={getTotalRecord}
                                        onChangeRowsPerPage={isListView ? getListView : getLogHistory}
                                        // onChangePage={handlePageChange}
                                    />
                                </div>

                                {isModel && <Modal title={"Transaction Details"} width={600} open={isModel} onCancel={() => setModel(false)} footer={null}>
                                    <div className='row'>
                                        <div className='col-md-12 form-group'><div className="project-info-box text-primary">
                                            <div className="row col-md-12">
                                                <div className="col-md-6">
                                                    <p><b>User ID :</b> {isModelData?.toUserData?.username}</p>
                                                    <p><b>Name :</b> {isModelData?.toUserData?.name}</p>
                                                    <p><b>Mobile :</b> {isModelData?.toUserData?.mobile}</p>
                                                    <p><b>Transaction Id :</b> {isModelData?.transactionId}</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <p><b>Amount :</b> {isModelData?.transactionAmt}</p>
                                                    <p><b>Commission :</b> {isModelData?.commission}</p>
                                                    <p><b>Service Charge :</b> {isModelData?.serviceCharge}</p>
                                                    <p><b>TDS :</b> {isModelData?.tds}</p>
                                                </div>
                                            </div>
                                            <Divider />
                                            <div className="row col-md-12">
                                                <div className="form-group col-md-6">
                                                    <label>Amount</label>
                                                    <input type="text" className={`form-control normal-light ${getDataError && getDataError.amount ? "is-invalid" : ""}`} name="amount" maxLength={12} value={getDataField && getDataField.amount} onKeyDown={isNumber} onChange={(e) => onChangeValue(e)} ref={amountInput} placeholder="Amount" />
                                                    {getDataError && getDataError.amount && <span className="error text-danger">The field is required</span>}
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label>Transaction Id</label>
                                                    <input type="text" className={`form-control normal-light ${getDataError && getDataError.transactionId ? "is-invalid" : ""}`} name="transactionId" value={getDataField && getDataField.transactionId} onChange={(e) => onChangeValue(e)} ref={transactionIdInput} placeholder="Transaction Id" />
                                                    {getDataError && getDataError.transactionId && <span className="error text-danger">The field is required</span>}
                                                </div>
                                            </div>
                                            <div className="form-group col-md-12">
                                                <label>Remark</label>
                                                <textarea className={`form-control normal-light ${getDataError && getDataError.remark ? "is-invalid" : ""}`} name="remark" onChange={(e) => onChangeValue(e)} rows={5} >{getDataField && getDataField.remark}</textarea>
                                                {getDataError && getDataError.remark && <span className="error text-danger">The field is required</span>}
                                            </div>
                                            <div className="float-right">
                                                <button onClick={() => handleSubmit()} className="btn btn-primary pointer ml-3">Submit</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Modal>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReserveBalance;